import { createContext } from "react";
import {
  Fortune,
  GetFortuneRes,
  GetTelFortuneRes,
  SWRResponse,
  TelFortune,
} from "shared/types";
import { KeyedMutator } from "swr";

export type MenuContextValue = Partial<
  SWRResponse<GetFortuneRes | GetTelFortuneRes>
> & {
  menu: Fortune | TelFortune;
};

export const menuContext = createContext<MenuContextValue>({
  menu: null,
  isLoading: false,
  isError: false,
  mutate: (() => {}) as KeyedMutator<GetFortuneRes | GetTelFortuneRes>,
});
